<template>
    <breadCrumbs title="Invoice" main="Ecommerce" title1="Invoice" />
    <div class="container invoice" id="print">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div>
                                <div class="row invo-header">
                                    <div class="col-sm-6">
                                        <div class="d-flex">
                                            <div class="d-flex-left"><router-link to="/dashboard/default"><img
                                                        class="d-flex-object img-60"
                                                        src="@/assets/images/logo/logo-icon.png" alt=""></router-link></div>
                                            <div class="flex-grow-1 m-l-20">
                                                <h2 class="d-flex-heading f-w-600">Koho</h2>
                                                <p>hello@koho.in<br><span class="digits">289-335-6503</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="text-md-end text-xs-center">
                                            <h3>Invoice #<span class="digits counter"><number
                                class="bold "
                                ref="number1"
                                :from="0"
                                :to="1069"
                                :duration="5"
                                :delay="0"
                                easing="Power1.easeOut"
                              /></span></h3>
                                            <p>Issued: May<span class="digits"> 27, 2023</span><br> Payment Due: June <span
                                                    class="digits">27, 2023</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row invo-profile">
                                <div class="col-xl-4">
                                    <div class="invo-profile-left">
                                        <div class="d-flex">
                                            <div class="d-flex-left"><img class="d-flex-object rounded-circle img-60"
                                                    src="@/assets/images/user/1.jpg" alt=""></div>
                                            <div class="flex-grow-1">
                                                <h4 class="d-flex-heading f-w-600">Johan Deo</h4>
                                                <p>JohanDeo@gmail.com <span class="digits">945-684-7956</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-8">
                                    <div class="invo-profile-right">
                                        <div id="project">
                                            <h6>Project Description</h6>
                                            <p>You're Only As Good As Your Last Collection, Which Is An Enormous Pressure.
                                                Jeans Represent Democracy In Fashion.Fashion Is About Dressing According To
                                                What's Fashionable.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <invoiceTable />
                                <div class="row mt-3">
                                    <div class="col-md-8">
                                        <div>
                                            <p class="legal"><strong>Thank you for your business!</strong> Payment is
                                                expected within 31 days; please process this invoice within that time. There
                                                will be a 5% interest charge per month on late invoices.</p>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <form class="text-end invo-pal">
                                            <input type="image" :src="require('@/assets/images/other-images/paypal.png')"
                                                alt="PayPal - The safer, easier way to pay online!">
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 text-center mt-3">
                            <button class="btn btn btn-primary me-2" type="button" @click="myFunction">Print</button>
                            <button class="btn btn-secondary" type="button">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import invoiceTable from "./invoiceTable.vue"
export default {
    components: { invoiceTable },
    methods: {
        myFunction() {
            var printContents = document.getElementById('print').innerHTML;
            var originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
        }
    }
}
</script>